import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getAllPosts, getPostsByCategory, getPostsByTag, searchPosts } from '../../services/blogServices';
import { BlogPost } from '../../types/BlogTypes';
import './BlogList.css';

const BlogList: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [categories, setCategories] = useState<string[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [searchParams] = useSearchParams();
  const categoryParam = searchParams.get('category');
  const tagParam = searchParams.get('tag');
  const searchParam = searchParams.get('q');

  useEffect(() => {
    // Obter todos os posts
    let filteredPosts: BlogPost[];
    
    if (categoryParam) {
      filteredPosts = getPostsByCategory(categoryParam);
    } else if (tagParam) {
      filteredPosts = getPostsByTag(tagParam);
    } else if (searchParam) {
      filteredPosts = searchPosts(searchParam);
    } else {
      filteredPosts = getAllPosts();
    }
    
    setPosts(filteredPosts);
    
    // Extrair categorias únicas
    const allCategories = Array.from(new Set(getAllPosts().map(post => post.category)));
    setCategories(allCategories);
    
    // Extrair tags únicas
    const allTags = Array.from(new Set(getAllPosts().flatMap(post => post.tags)));
    setTags(allTags);
  }, [categoryParam, tagParam, searchParam]);

  return (
    <div className="blog-container">
      <div className="blog-header">
        <h1>Blog</h1>
        <p>Dicas, tutoriais e insights sobre programação, automação e marketing digital</p>
      </div>
      
      <div className="blog-content">
        <div className="blog-sidebar">
          <div className="sidebar-section">
            <h3>Categorias</h3>
            <ul className="category-list">
              {categories.map((category) => (
                <li key={category}>
                  <Link 
                    to={`/blog?category=${encodeURIComponent(category)}`}
                    className={categoryParam === category ? 'active' : ''}
                  >
                    {category}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="sidebar-section">
            <h3>Tags</h3>
            <div className="tag-cloud">
              {tags.map((tag) => (
                <Link 
                  key={tag}
                  to={`/blog?tag=${encodeURIComponent(tag)}`}
                  className={`tag-item ${tagParam === tag ? 'active' : ''}`}
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </div>
        
        <div className="blog-main">
          {posts.length === 0 ? (
            <div className="no-posts">
              <p>Nenhum artigo encontrado para esta seleção.</p>
            </div>
          ) : (
            <div className="posts-grid">
              {posts.map((post) => (
                <div key={post.id} className="post-card">
                  <div className="post-image">
                    <img src={post.image} alt={post.title} />
                  </div>
                  <div className="post-content">
                    <div className="post-meta">
                      <span className="post-category">{post.category}</span>
                      <span className="post-date">{post.date}</span>
                    </div>
                    <h2>{post.title}</h2>
                    <p className="post-summary">{post.summary}</p>
                    <div className="post-footer">
                      <Link to={`/blog/${post.slug}`} className="read-more-button">
                        Ler artigo completo
                      </Link>
                      <div className="post-author">
                        <span>Por {post.author}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogList;